import { CSSProperties } from 'react';

import { AsyncJobName, AsyncJobStepName } from '@recurrency/core-api-schema/dist/asyncJobs/common';

import { ISODateStr } from 'types/hash-state';

export function calcDurationMsFromDates(startedAt: ISODateStr | undefined, finishedAt: ISODateStr | undefined) {
  if (!startedAt || !finishedAt) return 0;
  const start = new Date(startedAt);
  const end = new Date(finishedAt);
  return end.getTime() - start.getTime();
}

export function formatJobName(name: AsyncJobName) {
  if (name === AsyncJobName.UpdateItemLocationMinMaxes) return 'Export Min/Maxes';
  if (name === AsyncJobName.AutomatedMinMaxUpdate) return 'Automated Min/Max';
  // title case enum to spaced words e.g. ExportPurchaseOrder -> Export Purchase Order
  return name.replace(/([a-z])([A-Z])/g, '$1 $2');
}

export function formatJobStepName(name: AsyncJobStepName) {
  return name === AsyncJobStepName.ExportERPMinMaxes ? 'Export Min/Maxes batch' : name;
}

interface MinMaxUpdateRequest {
  item_id?: string;
  item_uid?: string;
  location_id?: string;
  new_min?: number;
  new_max?: number;
  new_replenishment_method?: string;
}

/**
 * Renders a min/max export step's payload as readable lines rather than raw JSON, e.g.
 * `ABC123 @ 10   min 3   max 4`. A single batch holds up to 100 item-locations, which is
 * unreadable as a JSON blob.
 */
export function formatMinMaxUpdatesLabel(updates: MinMaxUpdateRequest[]): string {
  return updates
    .map((update) => {
      const itemAndLocation = `${update.item_id ?? update.item_uid ?? '-'} @ ${update.location_id ?? '-'}`;
      const method = update.new_replenishment_method ? `   ${update.new_replenishment_method}` : '';
      return `${itemAndLocation}   min ${update.new_min ?? '-'}   max ${update.new_max ?? '-'}${method}`;
    })
    .join('\n');
}

export const iconStyle: CSSProperties = {
  fontSize: '22px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
};
